<template>
  <div class="home">
    <Banner />
    <Search />
    <Templates :loading="false" :moreEvent="designMoreEvent" :submit="designEvent" class="design_criteria_tem" :icon="true" title="中国电力设计标准与国际标准和国外标准比较研究" titleEn="A COMPARATIVE STUDY OF CHINESE ELECTRIC POWER DESIGN STANDARDS, INTERNATIONAL STANDARDS AND FOREIGN STANDARDS" subheading="《中国电力设计标准与国际标准和外国标准比较研究》是第一部结合“中国电力标准国际化工程”完成的大型专业、系列丛书。丛书共27卷，按照专业分别为电力工程勘测、火力发电工程、输变电工程、新能源工程等四部分。">
      <DesignCriteria />
      <Dialog :width="800" title="《中国电力设计标准与国际标准和国外标准比较研究》系列丛书" :data="designTextList" :visible="designFlag" @cancel="cancel" :footer="null" />
    </Templates>
    <Templates :loading="!renderDom.ConstructionStandard" ref="ConstructionStandard" data-key="ConstructionStandard" :moreEvent="constructionMoreEvent" :submit="constructionEvent" class="construction_standard_tem" :icon="true" title="中国电力施工部分标准与国际标准和国外标准比较研究" titleEn="A COMPARATIVE STUDY OF CHINESE ELECTRIC POWER CONSTRUCTION STANDARDS, INTERNATIONAL STANDARDS AND FOREIGN STANDARDS" subheading="国际工程火电/输变电建设技术标准应用研究课题针对土建、锅炉、汽机、电气、热控、焊接、调试和输变电八个专业进行中外建设技术标准的研究。">
      <ConstructionStandard v-if="renderDom.ConstructionStandard" />
      <Dialog :width="800" title="《中国电力设计标准与国际标准和国外标准比较研究》系列丛书" :data="constructionTestList" :visible="constructionFlag" @cancel="cancel" :footer="null" />
    </Templates>
    <Templates :loading="!renderDom.Publication" ref="Publication" data-key="Publication" :moreEvent="publicationMoreEvent" class="publication_tem" background="#FFF" title="中国标准英文版出版物" titleEn="ENGLISH PUBLICATIONS OF CHINESE STANDARDS">
      <Publication v-if="renderDom.Publication" />
    </Templates>
    <Templates :loading="!renderDom.StandardTrade" ref="StandardTrade" data-key="StandardTrade" :moreEvent="standardMoreEvent" class="standard_trade" background="#FFF" title="国别技术法规" titleEn="INTERNATIONAL TECHNICAL REGULATIONS">
      <StandardTrade v-if="renderDom.StandardTrade" />
    </Templates>
    <Templates :loading="!renderDom.GroupStandard" ref="GroupStandard" data-key="GroupStandard" class="group_standard_tem" @click.native="groupStandardSubmit" :moreEvent="false" title="中国电力规划设计协会团体标准（CEPPEA标准）" titleEn="CEPPEA STANDARD" subheading="为推动行业技术创新和管理标准化，中国电力规划设计协会响应国家大政方针， 2017年开始开展团体标准（CEPPEA标准）工作，建立了相关管理制度、标准体系、管理机构，并逐步开展了标准编制。
  CEPPEA标准以满足市场和创新需要为目标，关注工程总承包全过程，聚焦新技术、新产业、新业态和新模式，现阶段工作重点是填补标准空白和提升标准竞争力。">
      <GroupStandard v-if="renderDom.GroupStandard" />
    </Templates>
    <a-row class="standard_announcement">
      <a-col class="renewal_standard" :span="12">
        <RenewalStandard v-show="$FN.limitsVisible(['home_renewalStandard'])" />
      </a-col>
      <a-col class="announcement" :span="12">
        <Announcement v-show="$FN.limitsVisible(['home_announcement'])" />
      </a-col>
    </a-row>
    <Templates :loading="!renderDom.Map" ref="Map" data-key="Map" class="standard_trade" background="#FFF" title="世界标准地图" titleEn="WORLD STANDARD MAP">
      <Map v-if="renderDom.Map" />
    </Templates>
  </div>
</template>

<script>
import Banner from './banner';
import Search from './search';
import Templates from './templates';
import DesignCriteria from './templates/designCriteria'; // 中国电力设计标准与国际标准和国外标准比较研究
import ConstructionStandard from './templates/constructionStandard'; // 中国电力施工部分标准与国际标准和国外标准比较研究
import Publication from './templates/publication'; // 中国标准英文版出版物
import StandardTrade from './templates/standardTrade'; // 国别技术法规
import GroupStandard from './templates/groupStandard'; // 中国电力规划设计协会团体标准
import Map from './templates/map'; // 地图
import Announcement from './announcement'; // 平台公告
import RenewalStandard from './renewalStandard'; // 最近更新标准
import Dialog from './dialog'; // 提示
export default {
  name: "home",
  components: { Banner, Search, Templates, DesignCriteria, ConstructionStandard, Publication, StandardTrade, GroupStandard, Announcement, RenewalStandard, Map, Dialog },
  data() {
    return {
      time: null, // 时间容器
      designFlag: false,
      designTextList: [
        "由中国电力规划设计协会主导，11家设计院单位牵头，14家设计院单位参与编制。以中国标准为蓝本，将中国现行（截至2013年颁布）电力设计国家（GB）和行业（DL）标准与国际标准化组织IEC、IEEE、 ISO、欧盟、世界银行等，以及美国等11个国家标准分标准、分专业、分模块进行对比，对其中的安全、环保、主要参数和技术要求等重要条款做出评价（如宽严程度、差异原因等），提出使用指南。",
        "2010年12月，中国电力规划设计协会提出了《中国电力设计标准与国际标准和国外先进标准比较研究》项目建议书，并组织专家讨论通过了该项目建议书。2015年6月，完成27卷52分册的编写工作，按照专业分别为电力工程勘测、火力发电工程、输变电工程、新能源工程等四部分。《中国电力设计标准与国际标准和国外标准比较研究》的面世对推动中国电力设计标准国际化，打破中外技术交流屏障具有深远意义。"
      ],
      constructionFlag: false,
      constructionTestList: ["“国际工程火电/输变电建设技术标准应用研究课题”针对土建、锅炉、汽机、电气、热控、焊接、调试和输变电八个专业进行中外建设技术标准的研究，具体包括中外技术标准体系的研究、中外重要技术标准的翻译、中外技术标准的比较、国际工程中外标准比较应用案例研究、开发国际工程技术标准应用研究课题工作站，并开展相关培训活动。本课题的研究成果将用于指导企业快速掌握国际标准尤其是先进的国际技术标准、了解中外技术标准差异与关联，提升企业国际竞争力。通过对比、采用先进标准，有利于为客户提供高品质的产品和服务，增强市场信赖程度，从而拓展国际市场，在竞争中处于优势地位。"],
      renderDom: {
        ConstructionStandard: false,
        Publication: false,
        StandardTrade: false,
        GroupStandard: false,
        Map: false
      }, // 分批渲染首页防止卡顿
      subsidiary: this.$FN.elVisible(this.fn, { rootMargin: "0px 0px 250px 0px" }), // 组件懒加载
    }
  },
  created() {
    this.getRoute();
  },
  mounted() {
    this.getRef();
  },
  beforeDestroy() {
    this.clearTime();
  },
  methods: {
    clearTime() {
      clearTimeout(this.time);
      this.time = null;
    },
    getRef() {
      let refs = [];
      for (const key in this.renderDom) { refs.push(this.$refs[key].$el) };
      let fn = () => {
        switch (this.$FN.dataType(refs)) {
          case "Array": return this.subsidiary(refs);
          case "Undefined": return this.time = setTimeout(fn, 300);
        };
      };
      fn();
    },
    fn(target, _, subsidiary) {
      this.renderDom = { ...this.renderDom, [target.dataset.key]: true };
      subsidiary.unobserve(target);
      this.clearTime();
    },
    getRoute() {
      let { login = 0 } = this.$route.query;
      if (Number(login)) {
        if (this.$FN.getUser()) {
          this.$FN.logout().then(res => {
            if (res) this.$FN.visibleLogin(1);
          })
        } else {
          this.$FN.visibleLogin(1);
        }
      }
    },
    groupStandardSubmit() {
      if (this.$FN.getUser()) {
        this.$FN.limitsTips({ list: ["home_groupStandard_publish"] }).then(res => {
          if (res) {
            this.$router.$push({ path: 'ceppeaPublish' })
          }
        });
      } else {
        this.$FN.LoginTips();
      };
    },
    designEvent(value = false) {
      this.designFlag = value;
    },
    cancel() {
      this.designEvent(false);
      this.constructionEvent(false);
    },
    constructionEvent(value = false) {
      this.constructionFlag = value
    },
    designMoreEvent() {
      this.$FN.limitsTips({ list: ["home_designCriteria_list"] }).then(res => {
        if (res) {
          // this.$router.$push({ path: "container", query: { url: `${this.$FN.iframeUrl}/npg/kres/output` } })
          // window.open(`${window.location.origin}/container?url=${this.$FN.iframeUrl}/npg/kres/output`);
          this.$router.$push({ path: "benchmarking?type=0" });
        }
      });
    },
    constructionMoreEvent() {
      this.$FN.limitsTips({ list: ["home_constructionStandard_list"] }).then(res => {
        if (res) {
          // this.$router.$push({ path: "container", query: { url: `${this.$FN.iframeUrl}/npg/kres/output/details8` } })
          // window.open(`${window.location.origin}/container?url=${this.$FN.iframeUrl}/npg/kres/output/details8`);
          this.$router.$push({ path: "benchmarking?type=1" });
        }
      });
    },
    publicationMoreEvent() {
      this.$FN.limitsTips({ list: ["home_publication_list"] }).then(res => {
        if (res) {
          // this.$router.$push("/standardTranslation")
          window.open(`${window.location.origin}/standardTranslation`);
          // this.$router.$push({ path: "container", query: { url: `${this.$FN.iframeUrl}/page/standard_search_old?query_keys=出版译文` } })
        }
      });
    },
    standardMoreEvent() {
      this.$FN.limitsTips({ list: ["home_standardTrade_list"] }).then(res => {
        if (res) {
          this.$router.$push({ path: "/technicalRegulations" })
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>